export function makeDispatchClosureItems(data) {
    const closure = data?.dispatch ?? {};

    return [
        {
            label: "Outras anotações",
            value: closure?.finalizedAnotation ?? "",
        },
        {
            label: "Providência",
            value: closure?.dispatch_providence ?? "",
        },
    ];
}